import React , {Fragment, useState, useEffect } from 'react';
import CustomDatePicker from '../../datepicker/DatePicker';
const CampaignComponent=({
    isEdit,
    handleInputCampaignName,
    campaignInputValue,
    resetButton,
    saveCampaign,
    saveCampaignAfterEdit,
    startDate,
    endDate,
    selectedBanner,
    selectedQuery,
    handleRadioButtonChange,
    selectedRadioButton,
    handleSelectChange,
    bannerQuery,
    selectedResultTable,
    campaignResultTable,
    handleBannerChange,
    bannerCampaignQuery,
    setStartDate,
    setEndDate,
    divId,
    setDivId,
    adPath,
    setAdPath,
    showSelectedBanner,
    showSelectedQuery,
    showResultTable,
    handlePremiumServiceOrBanner
})=>{
    return(
        <Fragment>
            <div>
                {/* Title and Upload Button Row */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h4 style={{ color: '#333333', fontWeight: 'bold', margin: 0 }}>
                        {isEdit ? 'EDIT CAMPAIGN' : 'CREATE NEW CAMPAIGN'}
                    </h4>
                    <button 
                        onClick={() => handlePremiumServiceOrBanner('banner')}
                        style={{
                            backgroundColor: '#009900',
                            color: 'white',
                            border: '2px solid #009900',
                            borderRadius: '12px',
                            padding: '8px 16px',
                            fontWeight: 'bold',
                            cursor: 'pointer'
                        }}
                    >
                        Upload New Banner
                    </button>
                </div>

                {/* Main Container with Blue Border */}
                <div style={{ 
                    border: '2px solid #1395F2', 
                    borderRadius: '12px', 
                    padding: '30px',
                    backgroundColor: 'white',
                    boxShadow: '0 4px 12px rgba(19, 149, 242, 0.08), 0 2px 6px rgba(19, 149, 242, 0.04)',
                    marginBottom: '20px'
                }}>
                    {/* Campaign Name */}
                    <div style={{ marginBottom: '20px' }}>
                        <input
                            className="campaign-input"
                            placeholder="Campaign Name"
                            type="text"
                            onChange={(e) => handleInputCampaignName(e)}
                            value={campaignInputValue}
                        />
                    </div>
                    {/* Radio Buttons */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                name="use-query"
                                type="radio"
                                onChange={(e) => handleRadioButtonChange(e)}
                                value="use-query"
                                checked={selectedRadioButton === "use-query"}
                                style={{ accentColor: '#1395F2', transform: 'scale(1.2)', marginRight: '8px' }}
                            />
                            <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#333333' }}>Use Query</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                name="use-query"
                                type="radio"
                                onChange={(e) => handleRadioButtonChange(e)}
                                value="use-results-table"
                                checked={selectedRadioButton === "use-results-table"}
                                style={{ accentColor: '#1395F2', transform: 'scale(1.2)', marginRight: '8px' }}
                            />
                            <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#333333' }}>Use Results Table</label>
                        </div>
                    </div>
                    {/* Conditional Dropdown for Query/Results Table */}
                    {selectedRadioButton === "use-query" && (
                        <div style={{ marginBottom: '20px' }}>
                            <select className="use-result-table"
                                onChange={(e) => handleSelectChange(e)}
                                name="use-query"
                                value={selectedQuery}>
                                <option disabled hidden selected value={1}>Select Student Query</option>
                                {bannerQuery && bannerQuery.map((item, index) => (
                                    <option key={index} value={item.name}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                    )}
                    {selectedRadioButton === "use-results-table" && (
                        <div style={{ marginBottom: '20px' }}>
                            <select className="use-result-table"
                                onChange={(e) => handleSelectChange(e)}
                                name="use-result-table"
                                value={selectedResultTable}>
                                <option disabled hidden selected value={1}>Select Results Table</option>
                                {campaignResultTable && campaignResultTable.map((item, index) => (
                                    <option key={index} value={item.table_name}>{item.table_name}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* Banner Selection Dropdown */}
                    <div style={{ marginBottom: '20px' }}>
                        <select className="use-result-table"
                            onChange={(e) => handleBannerChange(e)}
                            name="use-result-table" 
                            value={selectedBanner}>
                            <option hidden selected disabled value={1}>Select Banner To Display</option>
                            {bannerCampaignQuery && bannerCampaignQuery.map((item, index) => (
                                <option key={index} value={item.name}>{item.name}</option>
                            ))}
                        </select>
                    </div>
                    {/* Date Range */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <div className="date-container">
                            <CustomDatePicker 
                                date={startDate}
                                setDate={setStartDate}
                                placeHolder="Start date"
                            />
                        </div>
                        <div style={{ padding: '0 20px' }}>
                            <span style={{ fontWeight: 'bold', color: '#333333' }}>To</span>
                        </div>    
                        <div className="date-container">
                            <CustomDatePicker 
                                date={endDate}
                                setDate={setEndDate}
                                placeHolder="End Date" 
                            />
                        </div>
                    </div> 
                    {/* Div ID and Ad Path */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '30px' }}>
                        <div style={{ width: '45%' }}>
                            <input 
                                className="campaign-input"
                                type="text"
                                value={divId}
                                placeholder="Div Id"
                                onChange={(e) => setDivId(e.target.value)} 
                            />      
                        </div>
                        <div style={{ width: '45%' }}>
                            <input 
                                className="campaign-input"
                                type="text"
                                value={adPath}
                                placeholder="Ad Path"
                                onChange={(e) => setAdPath(e.target.value)} 
                            />      
                        </div>
                    </div>   
                    {/* Action Buttons */}
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <button
                            className="campaign-button active-color"
                            onClick={isEdit ? saveCampaignAfterEdit : saveCampaign}
                            style={{
                                backgroundColor: '#009900',
                                color: 'white',
                                border: '2px solid #009900',
                                borderRadius: '12px',
                                width: '180px',
                                height: '45px',
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                        >
                            Save Campaign
                        </button>
                        <button 
                            onClick={resetButton} 
                            className="campaign-button inactive-color"
                            style={{
                                backgroundColor: 'white',
                                color: '#1395F2',
                                border: '2px solid #1395F2',
                                borderRadius: '12px',
                                width: '180px',
                                height: '45px',
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
export default CampaignComponent